<div
  class="tableau-wrapper"
  [style]="containerStyles"
  *ngIf="showTableau && url && token && !error"
>
  <tableau-viz
    id="tableauViz"
    [site]="'https://10az.online.tableau.com'"
    [token]="token"
    [src]="url"
    [height]="height"
    [width]="width"
    [embed]="'yes'"
    toolbar="hidden"
  ></tableau-viz>
</div>
  <div class="loader-container" *ngIf="!error&&thirdPartyEnabled&&!showTableau">
    <span ><i class="fas fa-spinner fa-spin"></i></span>
  </div>
  <div class="tableau-error-content" *ngIf="!thirdPartyEnabled">
    <p>
    {{'tableau_third_party_error'| translation}}.
  </p>
</div>

  <div class="tableau-error-content" *ngIf="error">
    <p>
      {{'tableau_error'| translation}}.
    </p>
  </div>
